import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import Blitz from "@/pages/Blitz";
import Battle from "@/pages/Battle";
import Verify from "@/pages/Verify";
import Share from "@/pages/Share";
import WinnerShare from "@/pages/WinnerShare";
import JoinTheBattle from "@/pages/JoinTheBattle";
import AdminLogin from "@/pages/AdminLogin";
import AdminTournaments from "@/pages/AdminTournaments";
import AdminTournamentDetail from "@/pages/AdminTournamentDetail";
import LiveTournament from "@/pages/LiveTournament";
import Leaderboard from "@/pages/Leaderboard";
import MatchDetail from "@/pages/MatchDetail";
import AdminGuard from "@/components/AdminGuard";
// Mock Interview Platform
import AdminMock from "@/pages/AdminMock";
import MockLogin from "@/pages/MockLogin";
import MockPending from "@/pages/MockPending";
import MockPositions from "@/pages/MockPositions";
import MockSession from "@/pages/MockSession";
import MockFeedback from "@/pages/MockFeedback";
import MockHistory from "@/pages/MockHistory";
import MockGuard from "@/components/MockGuard";

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Toaster
          position="top-center"
          toastOptions={{
            style: {
              border: "3px solid #0a0a0a",
              borderRadius: 0,
              boxShadow: "6px 6px 0 #0a0a0a",
              background: "#fff",
              color: "#0a0a0a",
              fontWeight: 700,
            },
          }}
        />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/blitz" element={<Blitz />} />
          <Route path="/battle" element={<Battle />} />
          <Route path="/verify/:certId" element={<Verify />} />
          <Route path="/share/:shareId" element={<Share />} />
          <Route path="/winner-share" element={<WinnerShare />} />
          {/* Primary URL — short, shareable, printed on booth banners */}
          <Route path="/join" element={<JoinTheBattle />} />
          {/* Backward-compat redirect for QR codes & old links */}
          <Route path="/jointhebattle" element={<Navigate to="/join" replace />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminGuard><AdminTournaments /></AdminGuard>} />
          <Route path="/admin/tournament/:id" element={<AdminGuard><AdminTournamentDetail /></AdminGuard>} />
          <Route path="/admin/mock" element={<AdminGuard><AdminMock /></AdminGuard>} />
          <Route path="/live" element={<LiveTournament />} />
          <Route path="/leaderboard" element={<Leaderboard />} />
          <Route path="/match/:roomId" element={<MatchDetail />} />
          {/* ── Mock Interview Platform ── */}
          <Route path="/mock" element={<MockLogin />} />
          <Route path="/mock/pending" element={<MockPending />} />
          <Route path="/mock/positions" element={<MockPositions />} />
          <Route path="/mock/session/:sessionId" element={<MockGuard><MockSession /></MockGuard>} />
          <Route path="/mock/feedback/:sessionId" element={<MockGuard><MockFeedback /></MockGuard>} />
          <Route path="/mock/history" element={<MockGuard><MockHistory /></MockGuard>} />
          {/* Catch-all: unknown routes redirect to home instead of blank screen */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}
